import clsx from 'clsx';
import React, { ReactNode } from 'react';
import Button from '../Button';
import { useButtonSizeLarge } from '../../utils/buttonSizes';

interface InfoContentProps {
  otherClasses?: string;
  icon: ReactNode;
  title: string;
  description?: string;
  buttonLabel: string;
  handleClick: () => void;
  warn?: boolean;
}

const InfoContent: React.FC<InfoContentProps> = ({
  otherClasses,
  buttonLabel,
  handleClick,
  icon,
  title,
  description,
  warn,
}) => {
  const infoContentClasses = clsx(
    otherClasses,
    'flex flex-col items-center gap-12 px-25',
  );
  const sizes = useButtonSizeLarge();

  return (
    <div className={infoContentClasses} data-testid="info-content">
      {icon}
      <div className="flex flex-col gap-2.5 text-center">
        <h1
          className={clsx(
            'font-semibold',
            warn ? 'text-brand-posh-pink' : 'text-brand-byzantine',
          )}
        >
          {title}
        </h1>
        {description && (
          <p
            className={clsx(
              'font-inter-variable text-lg font-medium italic md:text-2xl',
              warn ? 'text-brand-posh-pink' : 'text-brand-byzantine',
            )}
          >
            {description}
          </p>
        )}
      </div>
      <Button
        onClick={handleClick}
        otherClasses={clsx(
          'max-w-465 w-full',
          warn &&
            '!bg-brand-posh-pink hover:!bg-brand-posh-pink/90 hover:!text-white hover:!border-transparent',
        )}
        size={sizes}
      >
        {buttonLabel}
      </Button>
    </div>
  );
};

export default InfoContent;
